<template>
  <div></div>
</template>


<script>
    import Vue from '../../main.js';

    //loading modules for dashboard-tiles
    import notification from "../../Helpers/NotificationHelper";
    import routerHelper from "../../Helpers/RouterHelper";


    export default {

        data() {
            return {}
        },

        methods: {

          activateEmailAddress(code) {
            Vue.http.post(
                'api/v1/activate-email',
                {
                  code: code,
                }
            ).then(response => {

              //remove the query parameter py pushing to /
              routerHelper.routerPushToLogin(this)

              //show success msg
              notification.showSuccess(this, 'E-Mail Adresse erfolgreich bestätigt. Sie können sich nun einloggen.');

            }, error => {

              //remove the query parameter py pushing to /
              routerHelper.routerPushToLogin(this)

              notification.showError(this, 'Aktivierungscode für E-Mail Adresse konnte nicht gefunden werden');
            })
          }
        },

        beforeMount() {

          // get email address activation code
          let code = String(this.$route.query.code) || null;

          //get child data, if childId is set
          if (code) {
            this.activateEmailAddress(code);
          }
        }
    }

</script>